import React, { useState } from 'react';

const LatexOutput = ({ latexCode, jobPosting }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(latexCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = latexCode;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error('Fallback copy failed: ', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  const getJobExcerpt = () => {
    if (!jobPosting) return '';
    const words = jobPosting.split(' ');
    return words.length > 20 
      ? words.slice(0, 20).join(' ') + '...' 
      : jobPosting;
  };

  return (
    <div className="latex-output">
      <div className="latex-output-header">
        <h2>Generated LaTeX Resume Code</h2>
        <p>Customized for: {getJobExcerpt()}</p>
      </div>
      
      <div className="latex-code-container">
        <button 
          className={`copy-button ${copied ? 'copied' : ''}`}
          onClick={handleCopy}
          title="Copy LaTeX code to clipboard"
        >
          {copied ? '✓ Copied' : 'Copy Code'}
        </button>
        
        <textarea
          className="latex-code"
          value={latexCode}
          readOnly
          placeholder="Generated LaTeX code will appear here..."
        />
      </div>
      
      <div className="latex-output-header">
        <p className="usage-instructions">
          <strong>How to use:</strong> Copy the LaTeX code above and paste it into your LaTeX editor 
          (Overleaf, TeXworks, etc.) to compile your customized resume PDF.
        </p>
      </div>
    </div>
  );
};

export default LatexOutput;